// extracted by mini-css-extract-plugin
export default {"mainContent":"Layout_mainContent__a-TuI"};